import { render, staticRenderFns } from "./account-dropdown.vue?vue&type=template&id=30b87e36&scoped=true"
import script from "./account-dropdown.vue?vue&type=script&lang=js"
export * from "./account-dropdown.vue?vue&type=script&lang=js"
import style0 from "./account-dropdown.vue?vue&type=style&index=0&id=30b87e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b87e36",
  null
  
)

export default component.exports